<template lang="pug">
    Row
        Modal(v-model="isModalShow" :title="modalTitle" @on-visible-change="handleOnVisibleChange")
            pre.poptipPre(v-text="$options.filters.prettyJson(modalContent)")
            div(slot="footer")
                Button(type="primary" @click="isModalShow = false") {{ $t('global.close') }}
        Col(span="11")
            Card.listCard(dis-hover)
                p(slot="title") {{formItem.appliedTitle}}: {{ formValue.length }}
                List
                    draggable(
                        class="dragArea list-group"
                        v-model="formValue"
                        group="people"
                        v-bind="{animation: 200,group: 'description',disabled: false,ghostClass: 'ghost'}"
                        @start="drag = true"
                        @end="drag = false")
                        ListItem(
                            v-for="(element, idx) in formValue"
                            :key="`${idx}-${element.value}`")
                            Icon(type="md-reorder")
                            ListItemMeta(:description="element.value" style="width: 150px; white-space: nowrap; overflow-x:scroll")
                            template(slot="action")
                                li
                                    i-switch(v-model="element.isEnabled")
                                        Icon(type="md-checkmark"
                                            slot="open")
                                        Icon(type="md-close"
                                            slot="close")
                                li
                                    JsonPoptip(
                                        :title="element.value"
                                        :jsonData="options.find(e => e.value == element.value) ? options.find(e =>e.value == element.value).description  : {}"
                                        buttonText=""
                                        buttonIcon="md-eye"
                                    )
                                li
                                    Button(
                                        @click="moveToAvailable(element)"
                                        icon="md-trash"
                                        size="small"
                                    )
        Col(span="11" offset="2")
            Card.listCard(dis-hover)
                p(slot="title") {{formItem.availableTitle}}: {{ filteredOptions.length }}
                Input(v-model="filterOptionInput")
                div(class="ivu-list ivu-list-default ivu-list-horizontal ivu-list-split")
                    div(class="ivu-list-container")
                        ul(class="ivu-list-items")
                            li(v-for="(element, idx) in filteredOptions" :key="`${idx}-${element.value}`" class="ivu-list-item")
                                div(class="ivu-list-item-meta")
                                    div(class="ivu-list-item-meta-content")
                                        div(class="ivu-list-item-meta-description" style="width: 150px; white-space: nowrap; overflow-x:scroll" ) {{ element.label }}
                                            p
                                ul(class="ivu-list-item-action")
                                    li
                                        Button(@click.prevent="showPreview(element)" class="ivu-btn ivu-btn-default ivu-btn-small ivu-btn-icon-only")
                                            i(class="ivu-icon ivu-icon-md-eye")
                                    li
                                        Button(@click.prevent="moveToApplied(element)" class="ivu-btn ivu-btn-default ivu-btn-small ivu-btn-icon-only")
                                            i(class="ivu-icon ivu-icon-md-add-circle")
</template>
<script>
import draggable from "vuedraggable";
import { queryParamsFieldsCompletion } from "@/libs/rcmTableFieldsFunction";
import JsonPoptip from "@/components/JsonPoptip";

export default {
    components: { draggable, JsonPoptip },
    props: ["formItem", "formData", "value"],
    data() {
        return {
            formValue: this.value,
            options: this.formItem.options,
            queryParamsFields: this.formItem.queryParamsFields,
            filterOptionInput: "",
            isModalShow: false,
            modalTitle: "",
            modalContent: "",
        };
    },
    watch: {
        formValue: function () {
            // console.log(this.formValue);
            this.$emit("input", this.formValue);
        },
    },
    methods: {
        showPreview(element) {
            this.modalTitle = element.label;
            this.modalContent = element.description;
            this.isModalShow = true;
        },
        handleOnVisibleChange(visible) {
            if (!visible) {
                this.modalTitle = "";
                this.modalContent = "";
            }
        },
        async getRemoteOption(queryParams) {
            this.options = await this.formItem.remoteOptions(queryParams);
            // this.options = [...Array(800).keys()].map((e) => ({
            //     value: e,
            //     label: `${e}-label`,
            // }));
        },
        moveToApplied(element) {
            element.isEnabled = true;
            this.formValue.push(element);
        },
        moveToAvailable(element) {
            let elementIndex = this.formValue.findIndex((e) => e.value == element.value);
            this.formValue.splice(elementIndex, 1);
        },
    },
    mounted() {
        if (this.isRemoteOptions) {
            // 在意的欄位中, 只要一人符合 queryIf 條件, 即可以在 mounted 時獲取選項
            // 亦即: 所有在意的欄位都不符合時, 則不能在 mounted 時獲取選項
            let hasSomeFieldsMatch = this.queryParamsFields.some((field) =>
                field.queryIf(this.formData[field.fieldName])
            );
            let canGetOptions = this.queryParamsFields.length == 0 || hasSomeFieldsMatch;
            if (canGetOptions) this.getRemoteOption(this.queryParams);
        }
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);

        // 監聽需要注意的欄位
        this.queryParamsFields.forEach((field) => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function () {
                    return this.formData[fieldName];
                },
                function (newVal, oldVal) {
                    // console.log(`${this.formItem.key}: ${fieldName} changed from ${oldVal} to ${newVal}`);
                    if (queryIf(newVal)) {
                        this.$emit("input", this.formItem.defaultVal);
                        this.getRemoteOption(this.queryParams);
                    }
                },
                { deep: true }
            );
        });
    },
    computed: {
        // filter 是 全部-(搜尋+已套用)
        filteredOptions() {
            return this.options
                .filter((e) => e.label.includes(this.filterOptionInput))
                .filter((e) => !this.formValue.map((x) => x.value).includes(e.value));
        },
        isRemoteOptions() {
            return typeof this.formItem.remoteOptions == "function";
        },
        queryParams() {
            let queryParams = {};
            this.queryParamsFields.forEach((field) => {
                let { fieldName } = field;
                queryParams[fieldName] = this.formData[fieldName];
            });
            return queryParams;
        },
    },
    filters: {
        prettyJson: function (value) {
            try {
                return typeof value == "object"
                    ? JSON.stringify(value, null, 2)
                    : JSON.stringify(JSON.parse(value), null, 2);
            } catch (err) {
                return value;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.listCard {
    height: 500px;
    overflow-y: scroll;
}
.poptipPre {
    overflow: auto;
    height: auto;
    max-height: 600px;
    background-color: #eeeeee;
    word-break: normal !important;
    word-wrap: normal !important;
    white-space: pre !important;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/OneListDraggable.vue